import React from "react";
import clsx from "clsx";
import { motion } from "framer-motion";
import { CloseIcon } from "@/components/icons/CloseIcon";

const backdropVariants = {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.3, ease: "easeOut" } },
    exit: { opacity: 0, transition: { duration: 0.25, ease: "easeIn" } },
} as const;

const panelVariants = {
    initial: { y: "100%" },
    animate: { y: 0, transition: { duration: 0.3, ease: "easeOut" } },
    exit: { y: "100%", transition: { duration: 0.25, ease: "easeIn" } },
} as const;

interface PopupContainerProps {
    children?: React.ReactNode;
    className?: string;
    onClick?: (e: React.MouseEvent) => void;
    title?: React.ReactNode;
    onClose?: () => void;
}

export const PopupContainer: React.FC<PopupContainerProps> = ({ children, className, onClick, title, onClose }) => {
    return (
        <motion.div
            onClick={onClose}
            variants={backdropVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            className="absolute size-full overflow-hidden flex items-end bg-black/65 z-50"
        >
            <motion.div
                variants={panelVariants}
                initial="initial"
                animate="animate"
                exit="exit"
                className={clsx(
                    "flex w-full pt-4 px-4 flex-col gap-3 rounded-t-4xl border border-gray-500/15 backdrop-blur-lg",
                    className,
                )}
                style={{
                    background:
                        "linear-gradient(0deg, rgba(128, 128, 128, 0.15) 0%, rgba(128, 128, 128, 0.15) 100%), rgba(128, 128, 128, 0.65)",
                }}
                onClick={onClick}
            >
                {(title != null || onClose) && (
                    <div className="flex flex-row items-center justify-between w-full flex-shrink-0">
                        {title != null && <h2 className="text-2xl font-bold text-white">{title}</h2>}
                        {onClose && (
                            <button
                                type="button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onClose();
                                }}
                                className="flex flex-shrink-0 items-center justify-center rounded-full"
                                aria-label="Schließen"
                            >
                                <CloseIcon width={20} height={20} />
                            </button>
                        )}
                    </div>
                )}
                {children}
            </motion.div>
        </motion.div>
    );
};

export default PopupContainer;
